import Dashboard from '../containers/dashboard'
import DocumentsReadyManagement from '../containers/documents-ready-management'

const DocumentsReady = () => {
  return (
    <Dashboard>
      <DocumentsReadyManagement />
    </Dashboard>
  )
}

export default DocumentsReady
